import { render } from "./SyncAlert.vue?vue&type=template&id=07e86cac"
import script from "./SyncAlert.vue?vue&type=script&lang=js"
export * from "./SyncAlert.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__